<h1>Create Custom Field</h1>

<form [formGroup]="formGroup" novalidate>
    <mat-card appearance="outlined">
        <mat-card-content fxLayout="column">
             <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" >
                <mat-form-field appearance="outline" fxFlex="45">
                    <mat-label>Field Name</mat-label>
                    <input matInput formControlName="FieldName" placeholder="Enter field name (e.g., campaignId, field_name)" />
                    <mat-error *ngIf="formGroup.get('FieldName')?.hasError('required')">
                        Field Name is required
                    </mat-error>
                    <mat-error *ngIf="formGroup.get('FieldName')?.hasError('fieldNameLength')">
                        {{ formGroup.get('FieldName')?.getError('fieldNameLength')?.message }}
                    </mat-error>
                    <mat-error *ngIf="formGroup.get('FieldName')?.hasError('fieldNameStart')">
                        {{ formGroup.get('FieldName')?.getError('fieldNameStart')?.message }}
                    </mat-error>
                    <mat-error *ngIf="formGroup.get('FieldName')?.hasError('fieldNameFormat')">
                        {{ formGroup.get('FieldName')?.getError('fieldNameFormat')?.message }}
                    </mat-error>
                    <mat-error *ngIf="formGroup.get('FieldName')?.hasError('fieldNameUnique')">
                        {{ formGroup.get('FieldName')?.getError('fieldNameUnique')?.message }}
                    </mat-error>
                    <mat-error *ngIf="formGroup.get('FieldName')?.hasError('pending')">
                        Checking uniqueness...
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="45">
                    <mat-label>Display Label</mat-label>
                    <input matInput formControlName="DisplayLabel" placeholder="Enter display label" />
                    <mat-error *ngIf="formGroup.get('DisplayLabel')?.hasError('required')">
                        Display Label is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="45">
                    <mat-label>Vertex Type</mat-label>
                    <mat-select formControlName="VertexType">
                        <mat-option [value]="VertexTypes.Event">Event</mat-option>
                        <mat-option [value]="VertexTypes.Offer">Offer</mat-option>
                        <mat-option [value]="VertexTypes.Promo">Promo</mat-option>
                        <mat-option [value]="VertexTypes.OfferGroup">OfferGroup</mat-option>
                        <mat-option [value]="VertexTypes.Product">Product</mat-option>
                        <mat-option [value]="VertexTypes.ProductCategory">ProductCategory</mat-option>
                        <mat-option [value]="VertexTypes.Asset">Asset</mat-option>                        
                    </mat-select>
                    <mat-error *ngIf="formGroup.get('VertexType')?.hasError('required')">
                        Vertex Type is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="45">
                    <mat-label>Field Type</mat-label>
                    <mat-select formControlName="FieldType">
                        <mat-option [value]="FieldTypes.Text">Text</mat-option>
                        <mat-option [value]="FieldTypes.Number">Number</mat-option>
                        <mat-option [value]="FieldTypes.Textarea">Textarea</mat-option>
                        <mat-option [value]="FieldTypes.Email">Email</mat-option>
                        <mat-option [value]="FieldTypes.Url">Url</mat-option>
                        <mat-option [value]="FieldTypes.Date">Date</mat-option>
                        <mat-option [value]="FieldTypes.Select">Select</mat-option>
                        <mat-option [value]="FieldTypes.MultiSelect">Multi Select</mat-option>
                        <mat-option [value]="FieldTypes.Checkbox">Checkbox</mat-option>
                        <mat-option [value]="FieldTypes.Radio">Radio</mat-option>
                        <mat-option [value]="FieldTypes.Phone">Phone</mat-option>
                    </mat-select>
                    <mat-error *ngIf="formGroup.get('FieldType')?.hasError('required')">
                        This field is required
                    </mat-error>
                    
                </mat-form-field>

                <!-- Validation Rules Section -->
                <div appearance="outline" fxFlex="91" class="field-spacer">
                    <mat-expansion-panel >
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Validation Rules
                            </mat-panel-title>
                            <mat-panel-description>
                                Configure validation rules based on field type
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        
                        <div formGroupName="ValidationRules" fxLayout="column" fxLayoutGap="20px">
                            <!-- Required checkbox - available for all field types -->
                            <mat-checkbox formControlName="required">
                                Required
                            </mat-checkbox>

                            <!-- Text/Textarea validation rules -->
                            <div *ngIf="showTextValidationRules" fxLayout="row" fxLayoutGap="20px">
                                <mat-form-field appearance="outline" fxFlex="50">
                                    <mat-label>Min Length</mat-label>
                                    <input type="number" matInput formControlName="minLength" placeholder="Min length" min="0" />
                                </mat-form-field>
                                <mat-form-field appearance="outline" fxFlex="50">
                                    <mat-label>Max Length</mat-label>
                                    <input type="number" matInput formControlName="maxLength" placeholder="Max length" min="0" />
                                </mat-form-field>
                            </div>

                            <!-- Number validation rules -->
                            <div *ngIf="showNumberValidationRules" fxLayout="row" fxLayoutGap="20px">
                                <mat-form-field appearance="outline" fxFlex="50">
                                    <mat-label>Min Value</mat-label>
                                    <input type="number" matInput formControlName="min" placeholder="Min value" />
                                </mat-form-field>
                                <mat-form-field appearance="outline" fxFlex="50">
                                    <mat-label>Max Value</mat-label>
                                    <input type="number" matInput formControlName="max" placeholder="Max value" />
                                </mat-form-field>
                            </div>

                            <!-- Pattern validation rule -->
                            <div *ngIf="showPatternValidationRules" class="negativespace">
                                <mat-form-field appearance="outline">
                                    <mat-label>Pattern (Regex)</mat-label>
                                    <input matInput formControlName="pattern" placeholder="Enter regex pattern (e.g., ^[A-Za-z]+$)" />
                                    <mat-hint>Regular expression pattern for validation</mat-hint>
                                </mat-form-field>
                            </div>

                            <!-- Date/DateTime validation rules -->
                            <div *ngIf="showDateValidationRules" fxLayout="row" fxLayoutGap="20px">
                                <mat-form-field appearance="outline" fxFlex="50">
                                    <mat-label>Min Date</mat-label>
                                    <input type="date" matInput formControlName="minDate" placeholder="Min date" />
                                </mat-form-field>
                                <mat-form-field appearance="outline" fxFlex="50">
                                    <mat-label>Max Date</mat-label>
                                    <input type="date" matInput formControlName="maxDate" placeholder="Max date" />
                                </mat-form-field>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </div>

                <mat-form-field appearance="outline" fxFlex="45">
                    <mat-label>Display Order</mat-label>
                    <input type="number" matInput formControlName="DisplayOrder" placeholder="Enter display order" />
                    <mat-error *ngIf="formGroup.get('DisplayOrder')?.hasError('required')">
                        Display Order is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="45">
                    <mat-label>Is Read only</mat-label>
                    <mat-select formControlName="IsReadOnly">
                        <mat-option [value]="true">Yes</mat-option>
                        <mat-option [value]="false">No</mat-option>
                    </mat-select>
                    <mat-error *ngIf="formGroup.get('IsReadOnly')?.hasError('required')">
                        This field is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="45">
                    <mat-label>Is Hidden</mat-label>
                    <mat-select formControlName="IsHidden">
                        <mat-option [value]="true">Yes</mat-option>
                        <mat-option [value]="false">No</mat-option>
                    </mat-select>
                    <mat-error *ngIf="formGroup.get('IsHidden')?.hasError('required')">
                        This field is required
                    </mat-error>
                </mat-form-field>

                <!-- Options field - only shown for select, multiselect, radio field types -->
                <div *ngIf="requiresOptions(formGroup.get('FieldType')?.value)" fxFlex="45">
                    
                    <div fxLayout="column" fxLayoutGap="12px">
                        <div *ngFor="let option of getOptionsArray().controls; let i = index" fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="center">
                            <mat-form-field appearance="outline" fxFlex>
                                <mat-label>Option {{ i + 1 }}</mat-label>
                                <input matInput [formControl]="getOptionControl(i)" placeholder="Enter option value" />
                                <mat-error *ngIf="getOptionControl(i).hasError('required')">
                                    Option value is required
                                </mat-error>
                            </mat-form-field>
                            <button *ngIf="getOptionsArray().length > 1" mat-mini-fab color="warn" type="button" (click)="removeOption(i)" title="Remove option">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom: 16px;">
                        <mat-hint *ngIf="getOptionsArray().length > 0" style="display: block; margin-top: 8px;">
                            {{ getOptionsArray().length }} option(s) defined
                        </mat-hint>
                        <button mat-raised-button color="accent" type="button" (click)="addOption()" title="Add new option">
                            <mat-icon>add</mat-icon> Add Option
                        </button>
                    </div>
                    <mat-error *ngIf="getOptionsArray().length === 0">
                        At least one option is required for this field type
                    </mat-error>
                    
                </div>
            </div>
        </mat-card-content>
        <mat-card-actions fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
            <div fxLayout="row" [fxLayoutAlign]="customFieldId !== '0'?'space-between':'end'" class="mat-card-actions-details">
                <button *ngIf="customFieldId !== '0'" mat-raised-button type="button" color="warn" (click)="onDelete()">
                    Delete
                </button>
                <div fxLayout="row" fxLayoutAlign="end start" fxLayoutGap="16px"> 
                    <button mat-stroked-button type="reset" (click)="onCancel()" data-testid="EventsCancelButton">
                    Cancel
                    </button>
                    <button mat-raised-button type="button" (click)="onSubmit()" [disabled]="formGroup.invalid" color="accent">
                        {{ customFieldId === '0' ? 'Create Field' : 'Update Field' }}
                    </button>
                </div>
            </div>
           
        </mat-card-actions>
    </mat-card>
</form>